<template>
  <div class="my">
    <div class="nav-title">
      <a style="color: white">个人中心</a>
      <img class="money-icon" src="../../static/tixians.png" alt="" @click="handleWithdraw">
    </div>
    <div class="usable-balance">
      <div>可用预付款</div>
      <div class="usable-price">{{ userInfo.accountBalance }} 元</div>
    </div>
    <div class="money-content">
      <el-collapse accordion style="position: relative;" class="app-collapse" v-model="activeName">
        <div style="display: flex;justify-content: flex-end;padding: 7px 0 7px;font-size: 16px; position:absolute ;z-index: 99;width: auto;right: 37px;top: 3px;">
          <div style="text-align: center;">
            <div style="color: red; font-size: 12px">需补定金：{{dynamicTotalDeposit['Total']}} 元</div>
          </div>
        </div>
        <el-collapse-item :showAnimation="true" :open="true" name = '1' class="app-collapse-item" title="订单中心">
          <el-table :data="orderList" class="money-list" :expand-row-keys="expands" :row-key="getRowKeys">
            <el-table-column type="expand" :width = "3">
              <template slot-scope="scope">
                <div class="item-under">
                  <div class="item-row">
                    <div style="width: 50%">{{ scope.row.transactionId }}</div>
                    <div >{{ formatDateTime(scope.row.orderDate) }}</div>
                  </div>
                  <div class="item-row">
                    <div style="width: 50%">预定定金：{{ scope.row.paymentReceived }}</div>
                    <div>已补定金：{{ getDepositRequired(scope.row) }}</div>
                  </div>
                  <div class="item-row">
                    <div style="width: 50%" v-if="dynamicPrice[scope.row.preciousMetals + '-' + scope.row.transactionType]">
                      实物差价：
                      <a :style="dynamicDiffPriceColor[scope.row.id] ? 'color:#DA0A18;' : 'color:#09BB07'">{{ dynamicDiffPrice[scope.row.id] }}</a>
                    </div>
                    <div>来源:{{ scope.row.orderSource }}</div>
                  </div>
                  <div class="item-row">
                    <el-button size="mini" type="primary" @click="handleDeposit(scope.row)">补定金</el-button>
                    <div>金额：{{ parseFloat(dynamicDiffPrice[scope.row.id]) &lt; parseFloat(scope.row.paymentReceived) ? (parseFloat(dynamicDiffPrice[scope.row.id]) - parseFloat(scope.row.amountReceivable) + calcAmount(scope.row) - parseFloat(scope.row.fee)).toFixed(2) : 0}}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="订单类型" align="center" class="item-upper" :width="95" >
              <template slot-scope="scope">
                <span style="width: 23%;">
                  <a class="tab" :class="{ active: scope.row.transactionType === '销售' }">
                    {{ scope.row.transactionType === '回购' ? '卖料' : '买料' }}
                  </a>
                  <a style="color: #A8A095;">{{ scope.row.preciousMetals | pl() }}</a>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="数量(克)" align="center" prop="goldWeight" />
            <el-table-column  class="custom-label" label="预订价/当前价" align="center" :width="105" >
              <template slot-scope="scope">
                <span style="width: 31%;">
                  <a class="price-text" style="height: 17px; color: #A8A095">{{ parseFloat(scope.row.orderedPrice).toFixed(2) }}</a>
                  <a class="price-text" :style="dynamicStyle[scope.row.preciousMetals]">
                    {{ dynamicPrice[scope.row.preciousMetals + '-' + scope.row.transactionType] }}
                  </a>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  :style="{ backgroundColor: '#fdc800', borderColor: '#fdc800', borderRadius: '5px' }"
                  @click="handleSettlement(scope.row)">订单结算
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="has-more" ref="loadMore" @click="loadMoreContent">{{ hasMore ? '加载中...' : '到底拉！！！' }}</div>
        </el-collapse-item>
        <el-collapse-item :showAnimation="true" title="我的资料"  class="app-collapse-item">
          <div style="padding: 0 15px; background-color: rgb(255, 255, 255);--darkreader-inline-bgcolor: #181a1b;">
            <div>
              <div class="main-my-info">
                <div style="display: flex;">
                  <div style="width: 50px;display: inline-table;">名称：</div>
                  <div>
                    <div>{{ userInfo.customerName }}</div>
                  </div>
                </div>
                <div style="margin-left: 30%">手机号：{{ userInfo.phoneNumber }}</div>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <div @click="logout">
          <el-collapse-item :showAnimation="true" title="退出登陆"  class="app-collapse-item" />
        </div>
      </el-collapse>
    </div>
    <div style="margin: auto; width: 95%">
      <div style="font-size: 17px; margin: 10px 0 2px;">温馨提示：</div>
      <div>1.需要提料，来料请提前一个工作日联系客服备料备款！</div>
      <div>2.订单定金不足50%，需及时补足定金。定金不足0.01%，系统将自动对该笔订单结算。</div>
      <div>3.旧料回收快递费、保价费、提纯费、熔损等以实际为准！</div>
    </div>

    <el-dialog :visible.sync="syncDepositOpen" width="90%">
      <div class="drawer-main" style="border-radius: 10px; top: 15%; height: 450px; background-color: rgb(255, 255, 255); --darkreader-inline-bgcolor: #181a1b; ">
        <div style="height: 350px;">
          <div style="text-align: center; font-size: 18px; color: black">补定金</div>
          <div class="dialog-head" style="padding-top: 10px">
            <div style="color: #666666">客户名称:</div>
            <div style="color: black">{{userInfo.customerName}}</div>
          </div>
          <div class="dialog-head">
            <div style="color: #666666">预定单号:</div>
            <div style="color: black">{{depositOrder.transactionId}}</div>
          </div>
          <div class="dialog-head">
            <div style="color: #666666">预定时间:</div>
            <div style="color: black">{{formatDateTime(depositOrder.orderDate)}}</div>
          </div>
          <div class="dialog-head">
            <div style="color: #666666">订单类型:</div>
            <div style="color: black">{{"销售实物" + depositOrder.preciousMetals}}</div>
          </div>
          <div class="dialog-head">
            <div style="color: #666666">预定金重:</div>
            <div style="color: black">{{parseFloat(depositOrder.goldWeight).toFixed(3) + "g"}}</div>
          </div>
          <div class="dialog-head">
            <div style="color: #666666">预定价格:</div>
            <div style="color: black">{{parseFloat(depositOrder.orderedPrice).toFixed(2)}}</div>
          </div>
          <div class="dialog-head">
            <div style="color: #666666">当前价格:</div>
            <div style="color: #3ae833">{{parseFloat(dynamicPrice[depositOrder.preciousMetals + '-' + (depositOrder.transactionType === '销售' ? '回购' : depositOrder.transactionType === '回购' ? '销售' : depositOrder.transactionType) ]).toFixed(2)}}</div>
          </div>
          <div class="dialog-head">
            <div style="color: #666666">已收定金:</div>
            <div style="color: black">{{parseFloat(depositOrder.paymentReceived).toFixed(2)}}</div>
          </div>
          <div class="dialog-head">
            <div style="color: #666666">补入定金:</div>
            <div >
              <input maxlength="140" step="0.000000000000000001" enterkeyhint="done" pattern="[0-9]*" autocomplete="off" type="number" class="app-input" placeholder="请输入补入定金" v-model="inputDeposit">元
            </div>
          </div>
          <div class="dialog-head">
            <div style="color: #666666">当前余额:</div>
            <div style="color: black">{{userInfo.accountBalance}}</div>
          </div>
          <div class="dialog-head">
            <div style="color: #666666">补后余额:</div>
            <div style="color: black">{{parseInt(userInfo.accountBalance) - parseInt(this.inputDeposit)}}</div>
          </div>
        </div>
        <div style="line-height: 0; width: 90%; margin: 7px auto; text-align: center; padding: 10px 0; color: black;">以上信息无误请确认</div>
        <div class="app-dialog-button">
          <div style="width: 50%;"><el-button style="width: 40%; height: 100%; margin-left: 50%" type="primary" @click="depositSubmitForm">确认</el-button></div>
          <div style="width: 50%;"><el-button style="width: 40%; height: 100%; margin-left: 20%; background-color: #ccc; border: 1px solid #ccc;" type="primary"  @click="cancel">取消</el-button></div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="syncSettlementOpen" width="90%">
      <div class="drawer-main" style="border-radius: 10px; top: 15%; height: 440px; background-color: rgb(255, 255, 255); --darkreader-inline-bgcolor: #181a1b; ">
        <div style="height: 300px;">
          <div style="text-align: center; font-size: 20px; padding-top: 20px; width: 100%; color: black;">委托结算申请</div>
          <div class="dialog-head" style="padding-top: 10px">
            <div style="color: #666666">客户名称:</div>
            <div style="color: black">{{userInfo.customerName}}</div>
          </div>
          <div class="dialog-head">
            <div style="color: #666666">客户订单:</div>
            <div style="color: black">{{formatOrderType()}}</div>
          </div>
          <div class="dialog-head">
            <div style="color: #666666">结算重量:</div>
            <div style="color: rgb(0, 122, 255);">{{parseFloat(depositOrder.goldWeight).toFixed(3) + 'g'}}</div>
          </div>
          <div class="dialog-head">
            <div style="color: #666666">定购价格:</div>
            <div style="color: black">{{parseFloat(depositOrder.orderedPrice).toFixed(2)}}</div>
          </div>
          <div class="dialog-head">
            <div style="color: #666666">结算价格:</div>
            <div style="color: #3ae833">{{parseFloat(dynamicPrice[depositOrder.preciousMetals + '-' + depositOrder.transactionType]).toFixed(2)}}</div>
          </div>
          <div class="dialog-head">
            <div style="color: #666666">已收定金:</div>
            <div style="color: black">{{parseFloat(depositOrder.paymentReceived).toFixed(2)}}</div>
          </div>
          <div class="dialog-head">
            <div style="color: #666666">实物差价:</div>
            <div :style="dynamicDiffPriceColor[depositOrder.id] ? 'color:#09BB07;' : 'color:#DA0A18'">{{dynamicDiffPrice[depositOrder.id]}}</div>
          </div>
          <div class="dialog-head">
            <div style="color: #666666">手续费:</div>
            <div style="color: black">{{depositOrder.fee}}</div>
          </div>
        </div>
        <div style="width: 90%; margin: auto; font-size: 14px; color: black">备注：0点后结算，正常上班时间出结算单。</div>
        <div style="line-height: 0; width: 90%; margin: 7px auto; text-align: center; padding: 10px 0; color: black;">委托结算申请信息无误请确认</div>
        <div class="app-dialog-button">
          <div style="width: 50%;"><el-button style="margin-left: 50%; background-color: #ccc; border: 1px solid #ccc;" size="medium" type="primary"  @click="cancel">取消</el-button></div>
          <div style="width: 50%;"><el-button style="margin-left: 20%" size="medium" type="primary" @click="settlementSubmitForm">确认</el-button></div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync = "syncWithdrawOpen" width="90%">
      <div class="drawer-main" style="border-radius: 10px; top: 15%; height: 300px; background-color: rgb(255, 255, 255); --darkreader-inline-bgcolor: #181a1b; ">
        <div style="height: 180px">
          <div style="font-size: 20px; width: 100%; text-align: center; padding-top: 20px; color: black; font-weight: bold" >回款</div>
          <div style="font-size: 14px; color: black; margin-left: 5%">回款信息确认：</div>
          <div class="dialog-head-withdraw" style="width: 85%">
            <div style="color:black;">回款信息:</div>
            <div style="margin-left: 5px"><input maxlength="140" enterkeyhint="done" autocomplete="off" class="dialog-input-input" placeholder="请输入回款信息" v-model="withdrawParams.amount"/></div>
          </div>
          <div class="dialog-head-withdraw" style="width: 85%">
            <div style="color:black;">附言:</div>
            <div style="margin-left: 5px"><input maxlength="140" enterkeyhint="done" autocomplete="off" class="dialog-input-input" placeholder="选填" v-model="withdrawParams.postscript"/></div>
          </div>
          <div class="dialog-head-withdraw" style="width: 85%">
            <div style="color:black;">回款时间:</div>
            <div style="margin-left: 5px; width: 50%;"><input style="font-size: 8px" maxlength="180" enterkeyhint="done" autocomplete="off" class="dialog-input-input" v-model="withdrawParams.defaultText" readonly/></div>
          </div>
        </div>
        <div style="line-height: 45px; width: 100%; text-align: center; color: black; font-size: 14px">以上信息无误请确认</div>
        <div class="app-dialog-button">
          <div style="width: 50%;"><el-button style="margin-left: 50%; background-color: #ccc; border: 1px solid #ccc;" size="medium" type="primary"  @click="cancel">取消</el-button></div>
          <div style="width: 50%;"><el-button style="margin-left: 20%" size="medium" type="primary" @click="withdrawSubmit">确认</el-button></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {EventBus} from '../common/eventBus'

export default {
  name: 'My',
  components: {
  },
  data () {
    return {
      userInfo: {},
      activeName: '1',
      orderList: [],
      tableList: [],
      dynamicStyle: {},
      dynamicPrice: {},
      dynamicDiffPrice: {},
      dynamicDiffPriceColor: {},
      expands: [],
      getRowKeys (row) {
        return row.id
      },
      hasMore: false,
      queryParams: {
        pageIndex: 1,
        pageSize: 150
      },
      syncDepositOpen: false,
      depositOrder: {},
      inputDeposit: '',
      syncSettlementOpen: false,
      syncWithdrawOpen: false,
      withdrawParams: {
        amount: '',
        postscript: '',
        defaultText: '周一至周五早上10点到下午3点'
      },
      dynamicTotalDeposit: {},
      isButtonClickable: false,
      isWithdraw: false,
      isSettlementOrder: false
    }
  },
  created () {
    if (!this.GLOBAL.socket || this.GLOBAL.socket.readyState !== WebSocket.OPEN) {
      this.connectWebSocket()
    }
    EventBus.$on('tabListUpdated', updatedTabList => {
      this.tableList = updatedTabList
      this.updateDynamicData()
    })
    this.getUserInfo()
    // this.getUserOrder()
    localStorage.setItem('page', 'My')
  },
  mounted () {
    this.updateOrderList()
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  filters: {
    pl (data) {
      var min = data
      if (data.length === 4) {
        min = data.slice(0, 2)
      }
      if (data === '足金板料') {
        min = '黄金'
      }
      return min
    }
  },
  methods: {
    cancel () {
      this.syncDepositOpen = false
      this.syncSettlementOpen = false
      this.syncWithdrawOpen = false
      this.depositOrder = {}
      this.withdrawParams = {
        amount: '',
        explanation: '',
        defaultText: '周一至周五早上10点到下午3点'
      }
      this.inputDeposit = ''
    },
    updateDynamicData () {
      this.dynamicStyle = {
        '足金板料': this.handlePriceColor('足金板料'),
        '钯金板料': this.handlePriceColor('钯金板料'),
        '铂金板料': this.handlePriceColor('铂金板料'),
        '白银板料': this.handlePriceColor('白银板料')
      }

      this.dynamicPrice = {
        '足金板料-销售': this.handlePrice('足金板料', '销售'),
        '足金板料-回购': this.handlePrice('足金板料', '回购'),
        '钯金板料-销售': this.handlePrice('钯金板料', '销售'),
        '钯金板料-回购': this.handlePrice('钯金板料', '回购'),
        '铂金板料-销售': this.handlePrice('铂金板料', '销售'),
        '铂金板料-回购': this.handlePrice('铂金板料', '回购'),
        '白银板料-销售': this.handlePrice('白银板料', '销售'),
        '白银板料-回购': this.handlePrice('白银板料', '回购')
      }

      this.dynamicDiffPrice = {}
      for (const row of this.orderList) {
        this.dynamicDiffPrice[row.id] = this.handleDiffPrice(row)
      }

      this.dynamicDiffPriceColor = {}
      for (const row of this.orderList) {
        this.dynamicDiffPriceColor[row.id] = this.handleDiffPriceColor(row)
      }

      this.dynamicTotalDeposit = {
        'Total': this.getTotalDepositOther()
      }
    },
    getUserInfo () {
      this.$api.userInfo().then(response => {
        if (response.code === 200) {
          this.userInfo = response.data
          this.getUserOrder()
        } else {
          this.logout()
        }
      })
    },
    logout () {
      const vm = this
      this.$confirm('是否退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'app-logout'
      }).then(function () {
        localStorage.removeItem('token')
        vm.msgSuccess('退出成功')
        localStorage.setItem('page', 'My')
        vm.$router.push({ name: 'Login' })
      }).catch(action => {
        if (action === 'cancel') {
        }
      })
    },
    handlePrice (type, op) {
      if (!this.tableList) {
        return ''
      }
      switch (type) {
        case '足金板料':
          if (this.tableList.hasOwnProperty('GOLD')) {
            return op === '销售' ? this.tableList['GOLD'].Buy : this.tableList['GOLD'].Sell
          }
          break
        case '钯金板料':
          if (this.tableList.hasOwnProperty('PALLADIUM')) {
            return op === '销售' ? this.tableList['PALLADIUM'].Buy : this.tableList['PALLADIUM'].Sell
          }
          break
        case '铂金板料':
          if (this.tableList.hasOwnProperty('PLATINUM')) {
            return op === '销售' ? this.tableList['PLATINUM'].Buy : this.tableList['PLATINUM'].Sell
          }
          break
        case '白银板料':
          if (this.tableList.hasOwnProperty('SILVER')) {
            return op === '销售' ? this.tableList['SILVER'].Buy : this.tableList['SILVER'].Sell
          }
          break
      }
      return ''
    },
    handleDiffPrice (row) {
      if (!this.tableList) {
        return ''
      }
      let pm = row.preciousMetals
      let tt = row.transactionType
      let op = row.orderedPrice
      let np = ''
      let gw = row.goldWeight
      let ar = row.amountReceivable
      switch (pm) {
        case '足金板料':
          if (this.tableList.hasOwnProperty('GOLD')) {
            np = tt === '销售' ? this.tableList['GOLD'].Buy : this.tableList['GOLD'].Sell
          }
          break
        case '钯金板料':
          if (this.tableList.hasOwnProperty('PALLADIUM')) {
            np = tt === '销售' ? this.tableList['PALLADIUM'].Buy : this.tableList['PALLADIUM'].Sell
          }
          break
        case '铂金板料':
          if (this.tableList.hasOwnProperty('PLATINUM')) {
            np = tt === '销售' ? this.tableList['PLATINUM'].Buy : this.tableList['PLATINUM'].Sell
          }
          break
        case '白银板料':
          if (this.tableList.hasOwnProperty('SILVER')) {
            np = tt === '销售' ? this.tableList['SILVER'].Buy : this.tableList['SILVER'].Sell
          }
          break
      }
      const diff = tt === '销售' ? parseFloat(np) - parseFloat(op) : parseFloat(op) - parseFloat(np)
      return (diff * parseFloat(gw) + parseFloat(ar)).toFixed(2)
    },
    handleDiffPriceColor (row) {
      if (!this.tableList) {
        return false
      }
      let pm = row.preciousMetals
      let tt = row.transactionType
      let op = row.orderedPrice
      let np = ''
      switch (pm) {
        case '足金板料':
          if (this.tableList.hasOwnProperty('GOLD')) {
            np = tt === '销售' ? this.tableList['GOLD'].Buy : this.tableList['GOLD'].Sell
          }
          break
        case '钯金板料':
          if (this.tableList.hasOwnProperty('PALLADIUM')) {
            np = tt === '销售' ? this.tableList['PALLADIUM'].Buy : this.tableList['PALLADIUM'].Sell
          }
          break
        case '铂金板料':
          if (this.tableList.hasOwnProperty('PLATINUM')) {
            np = tt === '销售' ? this.tableList['PLATINUM'].Buy : this.tableList['PLATINUM'].Sell
          }
          break
        case '白银板料':
          if (this.tableList.hasOwnProperty('SILVER')) {
            np = tt === '销售' ? this.tableList['SILVER'].Buy : this.tableList['SILVER'].Sell
          }
          break
      }
      return parseFloat(np) > parseFloat(op)
    },
    handlePriceColor (type) {
      if (!this.tableList) {
        return ''
      }
      let color = ''
      let price = ''
      let minPrice = ''
      let maxPrice = ''
      switch (type) {
        case '足金板料':
          if (this.tableList.hasOwnProperty('GOLD')) {
            price = parseFloat(this.tableList['GOLD'].Sell)
            minPrice = parseFloat(this.tableList['GOLD'].L)
            maxPrice = parseFloat(this.tableList['GOLD'].H)
          }
          break
        case '钯金板料':
          if (this.tableList.hasOwnProperty('PALLADIUM')) {
            price = parseFloat(this.tableList['PALLADIUM'].Sell)
            minPrice = parseFloat(this.tableList['PALLADIUM'].L)
            maxPrice = parseFloat(this.tableList['PALLADIUM'].H)
          }
          break
        case '铂金板料':
          if (this.tableList.hasOwnProperty('PLATINUM')) {
            price = parseFloat(this.tableList['PLATINUM'].Sell)
            minPrice = parseFloat(this.tableList['PLATINUM'].L)
            maxPrice = parseFloat(this.tableList['PLATINUM'].H)
          }
          break
        case '白银板料':
          if (this.tableList.hasOwnProperty('SILVER')) {
            price = parseFloat(this.tableList['SILVER'].sell)
            minPrice = parseFloat(this.tableList['SILVER'].L)
            maxPrice = parseFloat(this.tableList['SILVER'].H)
          }
          break
      }
      color = price > (minPrice + maxPrice) / 2 ? 'color:red;' : price < (minPrice + maxPrice) / 2 ? 'color:#02BB5D' : ''
      return color
    },
    getDepositRequired (row) {
      if (parseFloat(row.amountReceivable) > parseFloat(row.paymentReceived)) {
        return (parseFloat(row.amountReceivable) - parseFloat(row.paymentReceived)).toFixed(2)
      }
      return 0
    },
    handleDeposit (row) {
      this.depositOrder = row
      this.syncDepositOpen = true
    },
    handleSettlement (row) {
      this.depositOrder = row
      this.syncSettlementOpen = true
    },
    handleQuery () {
      this.queryParams.pageSize = this.queryParams.pageSize + 10
      this.getUserOrder()
    },
    getUserOrder () {
      this.$api.userOrders(this.queryParams).then(response => {
        if (response.code === 200) {
          this.hasMore = response.data.count > this.queryParams.pageSize * this.queryParams.pageIndex
          this.orderList = response.data.list
          this.updateOrderList()
        } else {
          this.msgError(response.msg)
        }
      })
    },
    updateOrderList () {
      this.expands = this.orderList.map(row => row.id)
    },
    formatDateTime (dateTime) {
      const date = new Date(dateTime)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    depositSubmitForm () {
      if (this.isButtonClickable) {
        return
      }
      this.isButtonClickable = true

      if (parseInt(this.inputDeposit) < 2000) {
        this.msgInfo('补入定金不能小余2000')
      } else if (parseInt(this.inputDeposit) % 100 !== 0) {
        this.msgInfo('补入定金需是100的倍数')
      } else {
        this.$api.addDeposit({
          orderId: this.depositOrder.id,
          transactionId: this.depositOrder.transactionId,
          deposit: this.inputDeposit
        }).then(response => {
          if (response.code === 200) {
            this.syncDepositOpen = false
            this.depositOrder = {}
            this.inputDeposit = ''
            this.msgSuccess(response.msg)
            this.getUserInfo()
            this.getUserOrder()
          } else {
            this.msgError(response.msg)
          }
        })

        setTimeout(() => {
          this.isButtonClickable = false
        }, 3000)
      }
    },
    formatOrderType () {
      let ty = this.depositOrder.transactionType === '回购' ? '卖料' : '买料'
      return ty + this.depositOrder.preciousMetals + '结算'
    },
    settlementSubmitForm () {
      if (this.isSettlementOrder) {
        return
      }
      this.isSettlementOrder = true

      this.$api.settlementOrder({
        orderId: this.depositOrder.id,
        transactionId: this.depositOrder.transactionId,
        deposit: this.inputDeposit
      }).then(response => {
        if (response.code === 200) {
          this.syncSettlementOpen = false
          this.depositOrder = {}
          this.msgSuccess(response.msg)
          this.getUserInfo()
          this.getUserOrder()
        } else {
          this.msgError(response.msg)
        }
      })

      setTimeout(() => {
        this.isSettlementOrder = false
      }, 3000)
    },
    handleWithdraw () {
      this.syncWithdrawOpen = true
      this.withdrawParams.amount = ''
      this.withdrawParams.explanation = ''
    },
    withdrawSubmit () {
      if (this.isWithdraw) {
        return
      }
      this.isWithdraw = true

      this.$api.withdraw(
        this.withdrawParams
      ).then(response => {
        if (response.code === 200) {
          this.syncWithdrawOpen = false
          this.withdrawParams.amount = ''
          this.withdrawParams.explanation = ''
          this.withdrawParams.defaultText = '周一至周五早上10点到下午3点'
          this.msgSuccess(response.msg)
          this.getUserInfo()
        } else {
          this.msgError(response.msg)
        }
      })

      setTimeout(() => {
        this.isWithdraw = false
      }, 3000)
    },
    getTotalDepositOther () {
      if (this.orderList.length <= 0) {
        return '0'
      }
      let amountT = 0
      this.orderList.forEach(item => {
        let goldPrice = this.handlePrice(item.preciousMetals, item.transactionType)
        let amountFloat = this.handleDiff(item, goldPrice)
        let depositRate = 0
        if (amountFloat > 0) {
          depositRate = amountFloat / parseFloat(item.paymentReceived)
        }
        if (depositRate > 0.5) {
          amountT = amountT + amountFloat
        }
      })
      return amountT.toFixed(2)
    },
    handleDiff (item, price) {
      let diff = 0
      if (item.transactionType === '销售') {
        diff = parseFloat(item.orderedPrice) - parseFloat(price)
      } else {
        diff = parseFloat(price) - parseFloat(item.orderedPrice)
      }
      if (diff < 0) {
        return 0
      }

      let remain = parseFloat(item.amountReceivable) - parseFloat(item.paymentReceived)
      if (remain < 0) {
        remain = 0
      }

      let payAmount = diff * parseFloat(item.goldWeight) + parseFloat(item.fee) - remain
      if (payAmount < 0) {
        return 0
      }
      return payAmount
    },
    getTotalDeposit () {
      if (this.orderList.length <= 0) {
        return '0'
      }
      let totalDeposit = 0
      this.orderList.forEach(item => {
        let price = this.handleDiffPrice(item)
        if (parseFloat(price) - parseFloat(item.paymentReceived) < 0) {
          totalDeposit = totalDeposit + (parseFloat(item.amountReceivable) - parseFloat(price))
        }
      })
      return totalDeposit.toFixed(2)
    },
    handleScroll () {
      const el = this.$refs.loadMore
      const rect = el.getBoundingClientRect()

      if (rect.top <= window.innerHeight && this.hasMore) {
        this.loadMoreContent()
      }
    },
    loadMoreContent () {
      if (this.hasMore && !this.loading) {
        this.loading = true
        setTimeout(() => {
          this.handleQuery()
        }, 500)
        setTimeout(() => {
          this.loading = false
        }, 2000)
      }
    },
    calcAmount (row) {
      let desposit = 0
      if (parseFloat(row.amountReceivable) > parseFloat(row.paymentReceived)) {
        desposit = parseFloat(row.amountReceivable) - parseFloat(row.paymentReceived)
      }
      return desposit
    }
  }
}
</script>

<style scoped>
.my{
  background-color: #ffffff;
  font-size: 12px;
  line-height: 1.8;
  display: block;
}

.my .nav-title{
  height: 50px;
  line-height: 50px;
  border-bottom: 0.5px solid #cccccc;
  text-align: center;
  font-size: 20px;
  background-color: #fdc800;
  color: #000;
}

.my .nav-title .money-icon {
  position: relative;
  top: 4px;
  right: -32%;
  width: 20px;
  height: 20px;
}

.usable-balance {
  padding: 7px 0 7px;
  text-align: center;
  font-family: PingFang SC,serif;
  background-color: #ffffff;
  color: #000;
}

.usable-balance .usable-price {
  font-size: 18px;
}

.money-content{
  padding-bottom: 10px;
}

.app-collapse{
  background-color: rgb(24, 26, 27);
  width: 100%;
  display: flex;
  flex-direction: column;
  border: none;
}

.app-collapse-item .el-collapse-item__arrow {
  transition: transform 0.3s ease-in-out;
}

.app-collapse-item /deep/ .el-collapse-item__header {
  padding: 12px 12px;
  position: relative;
  line-height: 24px;
  flex-direction: row;
  justify-content: space-between;
  font-size: 16px;
  height: 24px;
}

.app-collapse-item /deep/ .el-collapse-item__arrow, .el-tabs__nav {
  transform: rotate(90deg);
}

.app-collapse-item /deep/ .el-collapse-item__arrow.is-active {
  transform: rotate(-90deg);
}

.head-titles {
  display: flex;
  padding: 7px 0;
  border-bottom: 1px solid #ccc;
  border-top: 1px solid #ccc;
  background: #fff;
}

.head-titles div {
  text-align: center;
  font-size: 14px;
  color: #666;
}

.main-my-info {
  width: 95%;
  margin: auto;
  height: 40px;
  line-height: 40px;
  display: flex;
}

.item-upper {
  display: flex;
  align-items: center;
  padding: 10px 0;
}

.tab {
  padding: 0 5px;
  margin-right: 4px;
  border-radius: 10px;
  background-color: rgb(40, 203, 40);
  color: #ffffff;
}

.tab.active {
  background-color: #f26c6b;
}

.price-text {
  display: block;
  height: 17px;
  margin-bottom: 5px;
}

.money-list{
  font-size: 13px;
  width: 100%;
  white-space: nowrap;
  overflow-x: auto;
}

.item-under {
  width: 100%;
  color: #6f6f6f;
  margin: auto;
  padding: 5px 20px 30px;
  box-sizing: border-box;
  border-bottom: 1px solid #ccc;
  background-color: #f1f1f1;
}

.item-row {
  display: flex;
}

.has-more {
  width: 100%;
  height: 50px;
  text-align: center;
  background-color: #ffffff;
}

.drawer-main{
  width: 90%;
  margin: auto;
  position: fixed;
  top: 15%;
  height: 60%;
  left: 5%;
  z-index: 992;
  border-radius: 10px;
}

.dialog-head{
  width: 90%;
  margin: auto;
  font-size: 15px;
  font-family: PingFang SC,serif;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e6e6e6;
  height: 27px;
  line-height: 27px;
}

.app-input{
  background-color: rgb(128, 255, 255);
  --darkreader-inline-bgcolor: #007f7f;
  font-weight: 600;
  width: 145px;
  font-size: 17px;
  outline: none;
  color: black;
}

.app-input::-webkit-inner-spin-button,
.app-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

.app-dialog-button{
  display: flex;
  justify-content: space-between;
}

.dialog-head-withdraw{
  width: 90%;
  margin: auto;
  font-size: 15px;
  font-family: PingFang SC,serif;
  display: flex;
  border-bottom: 1px solid #e6e6e6;
  height: 35px;
  line-height: 35px;
}

.dialog-input-input {
  width: 100%;
  border: none;
  background-color: rgb(255, 255, 255);
  --darkreader-inline-bgcolor: #181a1b;
  font-size: 15px;
  color: black;
}

.dialog-input-input:focus {
  outline: none;
}

</style>
<style>
.app-logout {
  width: 80% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/My.vue